<template src="./LabelPriority.html"></template>
<script>
export default {
  name: 'LabelPriority',
  props: {
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    background_color: {
      type: String,
      required: false,
      default: () => ''
    },
    color: {
      type: String,
      required: false,
      default: () => ''
    }
  },
  setup(props) {
    const label_current = props.label
    const background_color_current = props.background_color
    return {
      label_current, background_color_current
    }
  }
}
</script>
<style scoped lang="scss">
.label_priority {
  padding: 5px;
  border: 1px solid;
  border-radius: 5px;
  max-width: 120px;
  width: 120px;
  display: flex;
  align-content: center;
  justify-content: center;
  color: #ffffff;
}
</style>